import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { NotificationService } from '@core/services/notification.service';
import { AppData } from '@shared/models/appdata.model';
import { FeatureFeedback, Post, PostWrapper } from '../models/post.model';

export interface PostSearchResponse {
  totalRows: number;
  currentPage: number;
  take: number;
  data: Post[];
}

export interface PostSearchFilter {
  currentPage: number;
  take: number;
  searchPhrase: string;
}

enum Messages {
  getLatestNewsFailed = 'Noe gikk galt under henting av nyheter, prøv igjen senere.',
  getCategoriesFailed = 'Noe gikk galt under henting av kategorier, prøv igjen senere.',
  getPostFailed = 'Noe gikk galt under henting av nyhet, prøv igjen senere.',
}

@Injectable({
  providedIn: 'root',
})
export class NewsfeedService {
  private http = inject(HttpClient);
  private appData = inject(AppData);
  private notificationService = inject(NotificationService);

  apiUrl = `${this.appData.apiUrl}/api/v1`;

  getLatestNews(): Observable<Post[]> {
    const params = new HttpParams().set('take', '8');

    const url = `${this.apiUrl}/newsfeed/latest`;
    return this.http.get<Post[]>(url, { params }).pipe(
      catchError(res => {
        this.notificationService.error(Messages.getLatestNewsFailed);
        throw res;
      })
    );
  }

  getPost(slug: string): Observable<Post> {
    const url = `${this.apiUrl}/newsfeed/posts/${slug}`;
    return this.http.get<Post>(url).pipe(
      catchError(res => {
        this.notificationService.error(Messages.getPostFailed);
        throw res;
      })
    );
  }

  postSearch(postSearchFilter: PostSearchFilter): Observable<PostSearchResponse> {
    let url = `${this.apiUrl}/newsfeed/posts?`;

    url += `&currentPage=${postSearchFilter.currentPage.toString()}`;
    url += `&take=${postSearchFilter.take.toString()}`;
    url += `&searchPhrase=${postSearchFilter.searchPhrase}`;

    return this.http.get<PostSearchResponse>(url);
  }

  getCombinedPosts(): Observable<PostWrapper[]> {
    const url = `${this.apiUrl}/newsfeed/posts/combined?take=10`;
    return this.http.get<PostWrapper[]>(url);
  }

  getFeatureFeedbacks(): Observable<FeatureFeedback[]> {
    const url = `${this.apiUrl}/newsfeed/feature-feedbacks`;
    return this.http.get<FeatureFeedback[]>(url);
  }
}
